// Define the valid language keys
type LanguageKeys = any // Add other languages as needed

export const getPageMap = (
    localeText: LanguageKeys
): Record<
    string,
    {
        title?: string
        header?: string
        layout?: 'dashboard' | 'fullscreen'
        auth?: boolean
        hideNavigation?: boolean
        mobile?: boolean
    }
> => {
    return {
        '/login': {
            title: 'Login',
            header: '',
            layout: 'fullscreen',
            auth: false,
            mobile: true
        },
        '/maintenance': {
            title: 'Maintenance',
            header: 'Maintenance',
            layout: 'fullscreen',
            auth: false
        },
        '/business': {
            title: localeText?.common?.business,
            header: localeText?.common?.business,
            layout: 'dashboard',
            auth: true,
            mobile: true,
            hideNavigation: true
        },
        '/business/account': {
            title: localeText?.common?.account,
            header: localeText?.common?.account,
            layout: 'dashboard',
            auth: true
        },
        '/business/category': {
            title: localeText?.category?.category_list?.title,
            header: localeText?.category?.category_list?.title,
            layout: 'dashboard',
            auth: true
        },
        '/business/customer': {
            title: localeText?.common?.customer,
            header: localeText?.common?.customer,
            layout: 'dashboard',
            auth: true
        },
        '/business/customer/upload': {
            title: localeText?.CustomerExcel?.title || 'Import Customers',
            header: localeText?.CustomerExcel?.title || 'Import Customers',
            layout: 'dashboard',
            auth: true
        },
        '/business/customer-report': {
            title: localeText?.customer?.report?.title,
            header: localeText?.customer?.report?.title,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/inventory-count': {
            title: localeText?.InventoryCountLocale?.InventoryCount,
            header: localeText?.InventoryCountLocale?.InventoryCount,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/warehouse-report': {
            title: localeText?.NewReportLang?.WR,
            header: localeText?.NewReportLang?.WR,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/daily-cash-report': {
            title: "Daily Cash Report",
            header: "Daily Cash Report",
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/history': {
            title: localeText?.common?.history,
            header: localeText?.common?.history,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/purchase': {
            title: localeText?.PurchaseSales?.purcahse,
            header: localeText?.PurchaseSales?.purcahse,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/sales': {
            title: localeText?.PurchaseSales?.sales,
            header: localeText?.PurchaseSales?.sales,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/catalog-orders': {
            title: localeText?.catalog?.catalogOrders || 'Catalog Orders',
            header: localeText?.catalog?.catalogOrders || 'Catalog Orders',
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/purchase/new': {
            title: localeText?.PurchaseSales?.CreatePurchaseOrder,
            header: localeText?.PurchaseSales?.CreatePurchaseOrder,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/purchase/edit': {
            title: localeText?.PurchaseSales?.EditPurchase,
            header: localeText?.PurchaseSales?.EditPurchase,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/sales/new': {
            title: localeText?.PurchaseSales?.CreateSalesOrder,
            header: localeText?.PurchaseSales?.CreateSalesOrder,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/purchase/[id]': {
            title: localeText?.PurchaseSales?.PurchaseOrderDetails,
            header: localeText?.PurchaseSales?.PurchaseOrderDetails,
            layout: 'dashboard',
            auth: true
        },
        '/business/sales/[id]': {
            title: localeText?.PurchaseSales?.SalesOrderDetails,
            header: localeText?.PurchaseSales?.SalesOrderDetails,
            layout: 'dashboard',
            auth: true
        },
        '/business/catalog-orders/[id]': {
            title: localeText?.catalog?.catalogOrderDetails || 'Catalog Order Details',
            header: localeText?.catalog?.catalogOrderDetails || 'Catalog Order Details',
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/sales/edit': {
            title: localeText?.PurchaseSales?.EditSales,
            header: localeText?.PurchaseSales?.EditSales,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/manufacture': {
            title: localeText?.common?.manufacture,
            header: localeText?.common?.manufacture,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/manufacture-history': {
            title: localeText?.OtherComponent?.mfgHistoryTitle || "Manufacturing History",
            header: localeText?.OtherComponent?.mfgHistoryTitle || "Manufacturing History",
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/create-manufacture': {
            title: "Create Manufacture",
            header: "Create Manufacture",
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/available-warehouse': {
            title: localeText?.AW?.availablewarehouse,
            header: localeText?.AW?.availablewarehouse,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/receivables': {
            title: localeText?.NewReportLang?.Receivables || "Receivables",
            header: localeText?.NewReportLang?.Receivables || "Receivables",
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/product-daily-movement': {
            title: localeText?.NewReportLang?.DM,
            header: localeText?.NewReportLang?.DM,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/others': {
            title: localeText?.Assets?.others,
            header: localeText?.Assets?.others,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/replacement': {
            title: "Replacement",
            header: "Replacement",
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/return': {
            title: "Return",
            header: "Return",
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/returnn': {
            title: "Return",
            header: "Return",
            layout: 'dashboard',
            auth: true
            // mobile: true
        },

        '/business/return-history': {
            title: (localeText?.ReplacementReturn?.return || "Return") + ` ${localeText?.BatchLocal?.History}`,
            header: (localeText?.ReplacementReturn?.return || "Return") + ` ${localeText?.BatchLocal?.History}`,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },

        '/business/replacement-history': {
            title: (localeText?.ReplacementReturn?.replace || "Replacement") + ` ${localeText?.BatchLocal?.History}`,
            header: (localeText?.ReplacementReturn?.replace || "Replacement") + ` ${localeText?.BatchLocal?.History}`,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/replacement-return-history': {
            title: localeText?.ReplacementReturn?.replaceReturnHistory,
            header: localeText?.ReplacementReturn?.replaceReturnHistory,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/expense-category': {
            title: localeText?.Expenses?.ExpenseCategory,
            header: localeText?.Expenses?.ExpenseCategory,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/asset-category': {
            title: localeText?.Assets?.assetCategory,
            header: localeText?.Assets?.assetCategory,
            layout: 'dashboard',
            auth: true
            // mobile: true
        },
        '/business/low-stock-alert': {
            title: localeText?.common?.lowStockAlert,
            header: localeText?.common?.lowStockAlert,
            layout: 'dashboard',
            auth: true
        },
        '/business/expenses': {
            title: localeText?.Expenses?.ExpensesTitle,
            header: localeText?.Expenses?.ExpensesTitle,
            layout: 'dashboard',
            auth: true
        },
        '/business/assets': {
            title: 'assets',
            header: 'assets',
            layout: 'dashboard',
            auth: true
        },
        '/business/product': {
            title: localeText?.common?.product,
            header: localeText?.common?.product,
            layout: 'dashboard',
            auth: true
        },
        '/business/product/add': {
            title: localeText?.common?.add_product,
            header: localeText?.common?.add_product,
            layout: 'dashboard',
            auth: true
        },
        '/business/product/excel': {
            title: 'Add Products via Excel',
            header: 'Add Products via Excel',
            layout: 'dashboard',
            auth: true
        },
        '/business/warehouses/upload': {
            title: 'Add Warehouses via Excel',
            header: 'Add Warehouses via Excel',
            layout: 'dashboard',
            auth: true
        },
        '/business/product/edit': {
            title: localeText?.common?.edit_product,
            header: localeText?.common?.edit_product,
            layout: 'dashboard',
            auth: true
        },
        '/business/staff': {
            title: localeText?.common?.staff,
            header: localeText?.common?.staff,
            layout: 'dashboard',
            auth: true
        },
        '/business/warehouses': {
            title: localeText?.common?.warehouses,
            header: localeText?.common?.warehouses,
            layout: 'dashboard',
            auth: true
        },
        '/business/staff/add': {
            title: localeText?.common?.staff,
            header: localeText?.common?.staff,
            layout: 'dashboard',
            auth: true
        },
        '/business/stock-audit': {
            title: localeText?.common?.stock_audit,
            header: localeText?.common?.stock_audit,
            layout: 'dashboard',
            auth: true
        },
        '/business/transfer-items': {
            title: localeText?.common?.tranferOrder,
            header: localeText?.common?.tranferOrder,
            layout: 'dashboard',
            auth: true
        },

        '/business/transfer-items/add': {
            title: localeText?.common?.AddtranferOrder,
            header: localeText?.common?.AddtranferOrder,
            layout: 'dashboard',
            auth: true
        },
        '/business/transfer-items/edit': {
            title: 'Edit',
            header: 'Edit',
            layout: 'dashboard',
            auth: true
        },
        '/business/stock-in': {
            title: localeText?.common?.stock_in,
            header: localeText?.common?.stock_in,
            layout: 'dashboard',
            auth: true
        },
        '/business/stock-out': {
            title: localeText?.common?.stock_out,
            header: localeText?.common?.stock_out,
            layout: 'dashboard',
            auth: true
        },
        '/business/stock-in/excel': {
            title: "excel",
            header: "excel",
            layout: 'dashboard',
            auth: true
        },
        '/business/stock-out/excel': {
            title: "excel",
            header: "excel",
            layout: 'dashboard',
            auth: true
        },
        '/business/dashboard': {
            title: localeText?.common?.dashboard,
            header: localeText?.common?.dashboard,
            layout: 'dashboard',
            auth: true
        },
        '/business/supplier': {
            title: localeText?.common?.supplier,
            header: localeText?.common?.supplier,
            layout: 'dashboard',
            auth: true
        },
        '/business/supplier/upload': {
            title: localeText?.SupplierExcel?.title || 'Import Suppliers',
            header: localeText?.SupplierExcel?.title || 'Import Suppliers',
            layout: 'dashboard',
            auth: true
        },
        '/business/report': {
            title: localeText?.accounting?.accounting_report || 'Accounting Report',
            header: localeText?.accounting?.accounting_report || 'Accounting Report',
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/stock-report': {
            title: localeText?.stock_report?.title,
            header: localeText?.stock_report?.title,
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/onboarding': {
            title: localeText?.onboarding?.welcome,
            header: localeText?.onboarding?.welcome,
            layout: 'fullscreen',
            auth: true,
            hideNavigation: true,
            mobile: true
        },
        '/business/payment/order': {
            title: localeText?.payment?.order.title,
            header: localeText?.payment?.order.title,
            layout: 'fullscreen',
            auth: true,
            hideNavigation: true
        },
        '/privacy': {
            title: 'Privacy',
            header: '',
            layout: 'fullscreen',
            auth: false,
            mobile: true
        },
        '/delete-account': {
            title: 'Delete Account',
            header: '',
            layout: 'fullscreen',
            auth: false,
            mobile: true || false
        },
        '/': {
            header: 'simplystock.co',
            layout: 'fullscreen',
            auth: false
        },
        '/_error': {
            title: 'simplystock.co',
            header: 'simplystock.co',
            layout: 'fullscreen',
            auth: false
        },
        '/catalog/[slug]': {
            title: 'Catalog',
            header: '',
            layout: 'fullscreen',
            auth: false,
            mobile: true
        },
        '/catalog/[slug]/cart': {
            title: 'Cart',
            header: '',
            layout: 'fullscreen',
            auth: false,
            mobile: true
        },

        '/business/warehouse-details/[id]': {
            title: localeText?.product?.WarehouseDetails,
            header: localeText?.product?.WarehouseDetails,
            layout: 'dashboard',
            auth: true
        },

        '/subscription': {
            title: 'Subscription',
            header: "Subscription",
            layout: 'fullscreen',
            auth: false
        },
        '/business/batch': {
            title: 'Batch Management',
            header: "Batch Manage",
            layout: 'dashboard',
            auth: true
        },
        '/business/tally-import': {
            title: 'Tally Import',
            header: 'Tally Import',
            layout: 'dashboard',
            auth: true,
            mobile: true
        },
        '/business/tally-export': {
            title: 'Tally Export',
            header: 'Tally Export',
            layout: 'dashboard',
            auth: true,
            mobile: true
        }
    }
}
